<template>
  <div class="mobile-menu" :class="{ 'is-active': isActive }">
    <div class="mobile-menu-overlay" @click="closeMenu"></div>
    
    <div class="mobile-menu-container">
      <div class="mobile-menu-header">
        <h2>{{ t('header.menu') || 'Menu' }}</h2>
        <button class="close-btn" @click="closeMenu">✕</button>
      </div>
      
      <div class="mobile-menu-content">
        <div class="mobile-search">
          <input type="text" :placeholder="t('header.search')" aria-label="Search">
          <button>🔍</button>
        </div>
        
        <div class="mobile-user-actions">
          <button class="user-action-btn" @click="openReleasePop">
            <span class="icon">📝</span>
            <span>{{ t('Release.drm') }}</span>
          </button>
          <button class="user-action-btn" @click="goIfLogin('/profile-information')">
            <span class="icon">👤</span>
            <span>{{ t('header.account') }}</span>
          </button>
          <!-- <button class="user-action-btn">
            <span class="icon">📍</span>
            <span>{{ t('header.storeFinder') || 'Store Finder' }}</span>
          </button> -->
          <!-- <router-link to="/cate" class="user-action-btn" @click="closeMenu">
            <span class="icon">🛒</span>
            <span>{{ t('header.cart') }}</span>
          </router-link> -->
          <button class="user-action-btn"  @click="goToMerchantJoin">
            <span class="icon">🏬</span>
            <span>{{ t('header.merchant')}}</span>
          </button>
          <button v-if="isLoggedIn" class="user-action-btn"  @click="handleLogout">
            <span class="icon">🚪</span>
            <span>{{ t('loginRegister.logout')}}</span>
          </button>
          <!-- 占位按钮，使布局整齐 如果新加是偶数注释掉-->
          <button class="user-action-btn placeholder-btn" disabled style="visibility: hidden;">
            <span class="icon"></span>
            <span></span>
          </button>
        </div>
        
        <nav class="mobile-nav">
          <ul class="mobile-nav-list">
            <li>
              <router-link to="./shop" @click="closeMenu">{{ t('header.products') }}</router-link>
            </li>
            <li class="expandable">
              <div class="expand-header">
                <router-link to="./allDepartments" @click="closeMenu">{{ t('header.departments') || 'Departments' }}</router-link>
                <button class="expand-btn" @click="toggleSubmenu('departments')">
                  {{ expandedMenus.includes('departments') ? '−' : '+' }}
                </button>
              </div>
              <ul v-if="expandedMenus.includes('departments')" class="submenu">
                <li v-for="category in categoryListData" :key="category.id">
                  <div @click.prevent="getCategoryLink(category.id, category.name)">{{ getCategoryName(category.name) }}</div>
                </li>
              </ul>
            </li>
            <li>
              <router-link to="/tender-list" @click="closeMenu">{{ t('header.tender') }}</router-link>
            </li>
            <li>
              <router-link to="./shop" @click="closeMenu">{{ t('header.deals') }}</router-link>
            </li>
            <li class="expandable" style="display: none;">
              <div class="expand-header">
                <router-link to="./shop">{{ t('header.services') }}</router-link>
                <button class="expand-btn" @click="toggleSubmenu('services')">
                  {{ expandedMenus.includes('services') ? '−' : '+' }}
                </button>
              </div>
              <ul v-if="expandedMenus.includes('services')" class="submenu">
                <li><router-link to="./delivery" @click="closeMenu">{{ t('home.services.delivery') }}</router-link></li>
                <li><router-link to="./installation" @click="closeMenu">{{ t('home.services.installation') }}</router-link></li>
                <li><router-link to="./design" @click="closeMenu">{{ t('home.services.design') }}</router-link></li>
              </ul>
            </li>
            <li style="display: none;">
              <router-link to="./shop" @click="closeMenu">{{ t('header.diy') }}</router-link>
            </li>
          </ul>
        </nav>
        
        <!-- <div class="language-switcher-container">
          <LanguageSwitcher />
        </div> -->
      </div>
      
      <div class="mobile-menu-footer">
        <div class="contact-info">
          <h3>{{ t('footer.customerService') }}</h3>
          <p>(437) 771-6666</p>
          <p>{{ t('footer.businessHours') || 'Mon-Sat: 8am-9pm, Sun: 9am-6pm' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { onedepartmentList } from '@/api/categoryList';
import { useRouter } from 'vue-router';
import { ElLoading, ElMessage } from 'element-plus'
import { removeToken } from '@/services/auth'
import { getToken } from '@/services/auth'

const { t, locale } = useI18n();
const { isActive } = defineProps<{
  isActive: boolean
}>();

interface Category {
  id: number;
  name: string;
}

const categoryListData = ref<Category[]>([])
const categoryParams = {
  "level": 1,
  "type": 1,
}
onedepartmentList(categoryParams).then(res => {
  categoryListData.value = res.data
})

const router = useRouter();

const getCategoryLink = (id: number, name: string) => {
  router.push({
    path: '/building-materials',
    query: {
      categoryId: id
    }
  });
  closeMenu();
}

const currentLang = computed(() => locale.value === 'en' ? 'en-US' : 'zh-CN');
const updateCurrentLang = async (lang: 'en-US' | 'zh-CN') => {
  locale.value = lang === 'en-US' ? 'en' : 'zh'
}
interface LanguageChangeEvent extends CustomEvent {
  detail: { lang: 'en-US' | 'zh-CN' }
}

window.addEventListener('languageChange', (event: Event) => {
  const customEvent = event as LanguageChangeEvent
  const newLang = customEvent.detail.lang
  updateCurrentLang(newLang)
})
const getCategoryName = (name: string) => {
  try {
    const translations = JSON.parse(name)
    return translations[currentLang.value]
  } catch (error) {
    // 如果解析失败，直接返回原始值
    return name
  }
}
// end监听语言切换事件

const emits = defineEmits(['close', 'open-login-pop','open-release-pop','logout']);

const expandedMenus = ref<string[]>([]);

function toggleSubmenu(menuId: string) {
  if (expandedMenus.value.includes(menuId)) {
    expandedMenus.value = expandedMenus.value.filter(id => id !== menuId);
  } else {
    expandedMenus.value.push(menuId);
  }
}

function goToMerchantJoin() {
  router.push('/merchants-join')
}

function closeMenu() {
  emits('close');
}
function goIfLogin(path: string) {
  const token = localStorage.getItem('token')
  if (token) {
    router.push(path)
  } else {
    openLoginPop()
  }
}
function openLoginPop() {
  closeMenu();
  emits('open-login-pop')
}
function openReleasePop() {
  closeMenu();
  emits('open-release-pop')
}

const isLoggedIn = ref(!!getToken())
// 在 setup 函数中添加
function handleLogout() {
  router.push('/#')
  removeToken()
  localStorage.removeItem('userInfo')
  // 通知父组件更新登录状态

  isLoggedIn.value = false
  emits('logout')
  // 关闭菜单
  closeMenu()
  // // 显示退出成功消息
  // ElMessage.success(useI18n().t('loginRegister.logoutSuccess'))
 
}
</script>

<style scoped lang="scss">
// Variables
$primary-color: #fb6e01; // Home Depot orange
$secondary-color: #fb6e01; // Home Depot blue
$white: #fff;
$dark-gray: #333;
$light-gray: #f8f9fa;
$border-color: #e0e0e0;
$animation-duration: 0.3s;

.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  visibility: hidden;
  
  &.is-active {
    visibility: visible;
    
    .mobile-menu-overlay {
      opacity: 1;
    }
    
    .mobile-menu-container {
      transform: translateX(0);
    }
  }
}

.mobile-menu-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity $animation-duration ease;
}

.mobile-menu-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 85%;
  max-width: 350px;
  height: 100%;
  background-color: $white;
  transform: translateX(100%);
  transition: transform $animation-duration ease;
  display: flex;
  flex-direction: column;
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid $border-color;
  
  h2 {
    margin: 0;
    font-size: 20px;
    color: $dark-gray;
  }
  
  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    color: $dark-gray;
    cursor: pointer;
  }
}

.mobile-menu-content {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
}

.mobile-search {
  margin-bottom: 20px;
  display: flex;
  
  input {
    flex: 1;
    padding: 10px 15px;
    border: 1px solid $border-color;
    border-right: none;
    border-radius: 4px 0 0 4px;
    font-size: 16px;
    
    &:focus {
      outline: none;
      border-color: $primary-color;
    }
  }
  
  button {
    background-color: $primary-color;
    color: $white;
    border: none;
    padding: 0 15px;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
  }
}

.mobile-user-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  
  .user-action-btn {
    flex: 1;
    min-width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: $light-gray;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    
    .icon {
      font-size: 24px;
      margin-bottom: 5px;
    }
    
    span {
      font-size: 14px;
    }
    
    &:hover {
      background-color: #e8e9eb; /* Slightly darker shade of light gray */
    }
  }
}

.mobile-nav {
  .mobile-nav-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    > li {
      border-bottom: 1px solid $border-color;
      
      > a, .expand-header > a {
        display: block;
        padding: 15px;
        color: $dark-gray;
        text-decoration: none;
        font-weight: bold;
        
        &:hover, &.router-link-active {
          color: $primary-color;
        }
      }
      
      &.expandable {
        .expand-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          a {
            flex: 1;
          }
          
          .expand-btn {
            background: none;
            border: none;
            font-size: 24px;
            color: $dark-gray;
            padding: 0 15px;
            cursor: pointer;
          }
        }
        
        .submenu {
          list-style: none;
          padding: 0;
          margin: 0;
          background-color: $light-gray;
          
          li {
            div {
              display: block;
              padding: 12px 15px 12px 30px;
              color: $dark-gray;
              text-decoration: none;
              
              &:hover, &.router-link-active {
                color: $primary-color;
              }
            }
          }
        }
      }
    }
  }
}

.mobile-menu-footer {
  padding: 25px 15px;
  background-color: $light-gray;
  border-top: 1px solid $border-color;
  
  .contact-info {
    text-align: center;
    
    h3 {
      margin: 0 0 10px 0;
      font-size: 16px;
      color: $dark-gray;
    }
    
    p {
      margin: 0 0 5px 0;
      font-size: 14px;
      color: #666;
    }
  }
}

.language-switcher-container {
  margin-top: 20px;
  padding: 10px 0;
  border-top: 1px solid $border-color;
}

.placeholder-btn {
  pointer-events: none;
}
</style>